module.exports = __webpack_public_path__ + "img/wxhy-icon.f693951f.png";